
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.margin = this.getBreakpointValue(this.blok?.margin)
      styles.maxWidth = this.getBreakpointValue(this.blok?.maxWidth)

      return styles
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    hbspt.forms.create({
      region: this.blok.region,
      portalId: this.blok.portal_id,
      formId: this.blok.form_id,
      target: '#hubspotform-' + this.blok.form_id,
      onFormReady: () => {
        // target buttion and add classes
        const buttonEl = this.$el.querySelector('.hs-button')

        if (buttonEl && this.blok.button_classes) {
          buttonEl.classList.add(this.blok.button_classes)
        }
        if (buttonEl && this.blok.button_styles) {
          buttonEl.style.cssText += this.blok.button_styles
        }
      },
    })
  },
}
